import NewCollectionPage from "./NewCollectionPage"

export default NewCollectionPage